import {NavbarService} from "../services/navbar.service";
import {RouterModule} from "@angular/router";
import {inject, NgModule} from "@angular/core";
import {UserComponent} from "./user/user.component";
import {MessageSettingsComponent} from "./message-settings/message-settings.component";
import {GestionePreferitiComponent} from "./gestione-preferiti/gestione-preferiti.component";


const PrePath = 'Impostazioni/';

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: PrePath + 'user-info',
        component: UserComponent,
      },
      {
        path: PrePath + 'message-settings',
        component: MessageSettingsComponent,
      },
      {
        path: PrePath + 'gestione-preferiti',
        component: GestionePreferitiComponent,
      }
    ]),
  ],
})
export class ImpostazioniRoutingModule {
}
